import { default as AbstractModal } from './_AbstractModal'

export default class ModalMenu extends AbstractModal {

    constructor(m) {
        super(m)

        // DOM
        if(document.getElementById('banner-app')) {
            this.$focusTrapContainer = [document.getElementById('header-toolbar'), document.getElementById('banner-app')]
        } else {
            this.$focusTrapContainer = document.getElementById('header-toolbar')
        }
    }

    onClose() {
        this.call('close', null, 'Header')
    }
}
